import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {isArray} from "util";

@Pipe({
 name: 'nl2br'
})

@Injectable()
export class nl2brPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }
}
